import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';
class Blog extends Component {
    render() {
        return (
            <div>
        
        {/*::breadcrumb part start::*/}
        <section className="breadcrumb blog_bg">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="breadcrumb_iner">
                  <div className="breadcrumb_iner_item">
                    <h2>blog</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*::breadcrumb part start::*/}
        {/*================Blog Area =================*/}
        <section className="blog_area area-padding">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 mb-5 mb-lg-0">
                <div className="blog_left_sidebar">
                  <article className="blog_item">
                    <div className="blog_item_img">
                      <img className="card-img rounded-0" src="img/blog/single_blog_1.png" alt="" />
                      <a href="#" className="blog_item_date">
                        <h3>15</h3>
                        <p>Jan</p>
                      </a>
                    </div>
                    <div className="blog_details">
                      <NavLink className="d-inline-block" to="/blogdetails">
                        <h2>Google inks pact for new 35-storey office</h2>
                        </NavLink>
                      <p>That dominion stars lights dominion divide years for fourth have don't stars is that he earth it
                        first without heaven in place seed it second morning saying.</p>
                      <ul className="blog-info-link">
                        <li><a href="#"><i className="far fa-user" /> Travel, Lifestyle</a></li>
                        <li><a href="#"><i className="far fa-comments" /> 03 Comments</a></li>
                      </ul>
                    </div>
                  </article>
                  <article className="blog_item">
                    <div className="blog_item_img">
                      <img className="card-img rounded-0" src="img/blog/single_blog_2.png" alt="" />
                      <a href="#" className="blog_item_date">
                        <h3>15</h3>
                        <p>Jan</p>
                      </a>
                    </div>
                    <div className="blog_details">
                    <NavLink className="d-inline-block" to="/blogdetails">
                        <h2>Google inks pact for new 35-storey office</h2>
                      </NavLink>
                      <p>That dominion stars lights dominion divide years for fourth have don't stars is that he earth it
                        first without heaven in place seed it second morning saying.</p>
                      <ul className="blog-info-link">
                        <li><a href="#"><i className="far fa-user" /> Travel, Lifestyle</a></li>
                        <li><a href="#"><i className="far fa-comments" /> 03 Comments</a></li>
                      </ul>
                    </div>
                  </article>
                  <article className="blog_item">
                    <div className="blog_item_img">
                      <img className="card-img rounded-0" src="img/blog/single_blog_3.png" alt="" />
                      <a href="#" className="blog_item_date">
                        <h3>15</h3>
                        <p>Jan</p>
                      </a>
                    </div>
                    <div className="blog_details">
                    <NavLink className="d-inline-block" to="/blogdetails">
                        <h2>Google inks pact for new 35-storey office</h2>
                      </NavLink>
                      <p>That dominion stars lights dominion divide years for fourth have don't stars is that he earth it
                        first without heaven in place seed it second morning saying.</p>
                      <ul className="blog-info-link">
                        <li><a href="#"><i className="far fa-user" /> Travel, Lifestyle</a></li>
                        <li><a href="#"><i className="far fa-comments" /> 03 Comments</a></li>
                      </ul>
                    </div>
                  </article>
                  <article className="blog_item">
                    <div className="blog_item_img">
                      <img className="card-img rounded-0" src="img/blog/single_blog_4.png" alt="" />
                      <a href="#" className="blog_item_date">
                        <h3>15</h3>
                        <p>Jan</p>
                      </a>
                    </div>
                    <div className="blog_details">
                    <NavLink className="d-inline-block" to="/blogdetails">
                        <h2>Google inks pact for new 35-storey office</h2>
                      </NavLink>
                      <p>That dominion stars lights dominion divide years for fourth have don't stars is that he earth it
                        first without heaven in place seed it second morning saying.</p>
                      <ul className="blog-info-link">
                        <li><a href="#"><i className="far fa-user" /> Travel, Lifestyle</a></li>
                        <li><a href="#"><i className="far fa-comments" /> 03 Comments</a></li>
                      </ul>
                    </div>
                  </article>
                  <article className="blog_item">
                    <div className="blog_item_img">
                      <img className="card-img rounded-0" src="img/blog/single_blog_5.png" alt="" />
                      <a href="#" className="blog_item_date">
                        <h3>15</h3>
                        <p>Jan</p>
                      </a>
                    </div>
                    <div className="blog_details">
                    <NavLink className="d-inline-block" to="/blogdetails">
                        <h2>Google inks pact for new 35-storey office</h2>
                      </NavLink>
                      <p>That dominion stars lights dominion divide years for fourth have don't stars is that he earth it
                        first without heaven in place seed it second morning saying.</p>
                      <ul className="blog-info-link">
                        <li><a href="#"><i className="far fa-user" /> Travel, Lifestyle</a></li>
                        <li><a href="#"><i className="far fa-comments" /> 03 Comments</a></li>
                      </ul>
                    </div>
                  </article>
                  <nav className="blog-pagination justify-content-center d-flex">
                    <ul className="pagination">
                      <li className="page-item">
                        <a href="#" className="page-link" aria-label="Previous">
                          <i className="ti-angle-left" />
                        </a>
                      </li>
                      <li className="page-item">
                        <a href="#" className="page-link">1</a>
                      </li>
                      <li className="page-item active">
                        <a href="#" className="page-link">2</a>
                      </li>
                      <li className="page-item">
                        <a href="#" className="page-link" aria-label="Next">
                          <i className="ti-angle-right" />
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="blog_right_sidebar">
                  <aside className="single_sidebar_widget search_widget">
                    <form action="#">
                      <div className="form-group">
                        <div className="input-group mb-3">
                          <input type="text" className="form-control placeholder hide-on-focus" placeholder="Search Keyword" />
                          <div className="input-group-append">
                            <button className="btn" type="button"><i className="ti-search" /></button>
                          </div>
                        </div>
                      </div>
                      <button className="button rounded-0 primary-bg text-white w-100" type="submit">Search</button>
                    </form>
                  </aside>
                  <aside className="single_sidebar_widget post_category_widget">
                    <h4 className="widget_title">Category</h4>
                    <ul className="list cat-list">
                      <li>
                        <a href="#" className="d-flex">
                          <p>Resaurant food</p>
                          <p>(37)</p>
                        </a>
                      </li>
                      <li>
                        <a href="#" className="d-flex">
                          <p>Travel news</p>
                          <p>(10)</p>
                        </a>
                      </li>
                      <li>
                        <a href="#" className="d-flex">
                          <p>Modern technology</p>
                          <p>(03)</p>
                        </a>
                      </li>
                      <li>
                        <a href="#" className="d-flex">
                          <p>Product</p>
                          <p>(11)</p>
                        </a>
                      </li>
                      <li>
                        <a href="#" className="d-flex">
                          <p>Inspiration</p>
                          <p>(21)</p>
                        </a>
                      </li>
                      <li>
                        <a href="#" className="d-flex">
                          <p>Health Care</p>
                          <p>09</p>
                        </a>
                      </li>
                    </ul>
                  </aside>
                  <aside className="single_sidebar_widget popular_post_widget">
                    <h3 className="widget_title">Recent Post</h3>
                    <div className="media post_item">
                      <img src="img/post/post_1.png" alt="post" />
                      <div className="media-body">
                        <a href="single-blog.html">
                          <h3>From life was you fish...</h3>
                        </a>
                        <p>January 12, 2019</p>
                      </div>
                    </div>
                    <div className="media post_item">
                      <img src="img/post/post_2.png" alt="post" />
                      <div className="media-body">
                        <a href="single-blog.html">
                          <h3>The Amazing Hubble</h3>
                        </a>
                        <p>02 Hours ago</p>
                      </div>
                    </div>
                    <div className="media post_item">
                      <img src="img/post/post_3.png" alt="post" />
                      <div className="media-body">
                        <a href="single-blog.html">
                          <h3>Astronomy Or Astrology</h3>
                        </a>
                        <p>03 Hours ago</p>
                      </div>
                    </div>
                    <div className="media post_item">
                      <img src="img/post/post_4.png" alt="post" />
                      <div className="media-body">
                        <a href="single-blog.html">
                          <h3>Asteroids telescope</h3>
                        </a>
                        <p>01 Hours ago</p>
                      </div>
                    </div>
                  </aside>
                  <aside className="single_sidebar_widget tag_cloud_widget">
                    <h4 className="widget_title">Tag Clouds</h4>
                    <ul className="list">
                      <li>
                        <a href="#">project</a>
                      </li>
                      <li>
                        <a href="#">love</a>
                      </li>
                      <li>
                        <a href="#">technology</a>
                      </li>
                      <li>
                        <a href="#">travel</a>
                      </li>
                      <li>
                        <a href="#">restaurant</a>
                      </li>
                      <li>
                        <a href="#">life style</a>
                      </li>
                      <li>
                        <a href="#">design</a>
                      </li>
                      <li>
                        <a href="#">illustration</a>
                      </li>
                    </ul>
                  </aside>
                  <aside className="single_sidebar_widget instagram_feeds">
                    <h4 className="widget_title">Instagram Feeds</h4>
                    <ul className="instagram_row flex-wrap">
                      <li>
                        <a href="#">
                          <img className="img-fluid" src="img/post/post_5.png" alt="" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <img className="img-fluid" src="img/post/post_6.png" alt="" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <img className="img-fluid" src="img/post/post_7.png" alt="" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <img className="img-fluid" src="img/post/post_8.png" alt="" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <img className="img-fluid" src="img/post/post_9.png" alt="" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <img className="img-fluid" src="img/post/post_10.png" alt="" />
                        </a>
                      </li>
                    </ul>
                  </aside>
                  <aside className="single_sidebar_widget newsletter_widget">
                    <h4 className="widget_title">Newsletter</h4>
                    <form action="#">
                      <div className="form-group">
                        <input type="email" className="form-control placeholder hide-on-focus" placeholder="Enter email" required />
                      </div>
                      <button className="button rounded-0 primary-bg text-white w-100" type="submit">Subscribe</button>
                    </form>
                  </aside>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*================Blog Area =================*/}
        {/*::footer_part start::*/}
        <footer className="footer_part">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="footer_logo">
                  <a href="index.html" className="footer_logo_iner"> <img src="img/footer_logo.png" alt="#" /> </a>
                </div>
              </div>
              <div className="col-sm-6 col-lg-3">
                <div className="single_footer_part">
                  <h4>About Us</h4>
                  <p>Heaven fruitful doesn't over lesser days appear creeping seasons so behold bearing days open</p>
                  <div className="footer_icon social_icon">
                    <ul className="list-unstyled">
                      <li><a href="#" className="single_social_icon"><i className="fab fa-facebook-f" /></a></li>
                      <li><a href="#" className="single_social_icon"><i className="fab fa-twitter" /></a></li>
                      <li><a href="#" className="single_social_icon"><i className="fas fa-globe" /></a></li>
                      <li><a href="#" className="single_social_icon"><i className="fab fa-behance" /></a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-lg-3">
                <div className="single_footer_part">
                  <h4>Contact Info</h4>
                  <p>Address : Your address goes
                    here, your demo address.</p>
                  <p>Phone : +8880 44338899</p>
                  <p>Email : info@colorlib.com</p>
                </div>
              </div>
              <div className="col-sm-6 col-lg-3">
                <div className="single_footer_part">
                  <h4>Important Link</h4>
                  <ul className="list-unstyled">
                    <li><a href="#"> WHMCS-bridge</a></li>
                    <li><a href="#">Search Domain</a></li>
                    <li><a href="#">My Account</a></li>
                    <li><a href="#">Shopping Cart</a></li>
                    <li><a href="#">Our Shop</a></li>
                  </ul>
                </div>
              </div>
              <div className="col-sm-6 col-lg-3">
                <div className="single_footer_part">
                  <h4>Newsletter</h4>
                  <p>Heaven fruitful doesn't over lesser in days. Appear creeping seasons deve behold bearing days open
                  </p>
                  <div id="mc_embed_signup">
                    <form target="_blank" action="https://spondonit.us12.list-manage.com/subscribe/post?u=1462626880ade1ac87bd9c93a&id=92a4423d01" method="get" className="subscribe_form relative mail_part" required>
                      <input type="email" name="email" id="newsletter-form-email" placeholder="Email Address" className="placeholder hide-on-focus" required />
                      <button type="submit" name="submit" id="newsletter-submit" className="email_icon newsletter-submit button-contactForm"><i className="far fa-paper-plane" /></button>
                      <div className="mt-10 info" />
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-lg-12">
                <div className="copyright_text text-center">
                  <p>{/* Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. */}
                    Copyright © All rights reserved | This template is made with <i className="fa fa-heart" aria-hidden="true" /> by <a href="https://colorlib.com" target="_blank">Colorlib</a>
                    {/* Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. */}</p>
                </div>
              </div>
            </div>
          </div>
        </footer>
        {/*::footer_part end::*/}
      </div>
        );
    }
}

export default Blog;